import { UserAuthState, initialAuthState } from './slices/auth/auth-initial-state';

export type UserState = UserAuthState;

export const initialState: UserState = {
  ...initialAuthState,
};
